import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';
import { PastShiftsTable } from '@mews-commander/cashiers';

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/Finance/Cashier/_layout/$cashierId/PastShifts'
)({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.cashierShiftPagesMigration);
    },
    component: () => <PageComponent />,
    staticData: {
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
        title: TextKey.CashierShiftsPast,
        excludeBreadcrumb: true,
    },
});

const PageComponent = () => {
    const { cashierId } = Route.useParams();

    return <PastShiftsTable cashierId={cashierId} />;
};
